/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Business,
    BusinessFromJSON,
    BusinessFromJSONTyped,
    BusinessToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateBulkBusinessEnableBody
 */
export interface UpdateBulkBusinessEnableBody {
    /**
     * 
     * @type {Array<Business>}
     * @memberof UpdateBulkBusinessEnableBody
     */
    businesses: Array<Business>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBulkBusinessEnableBody
     */
    isEnabled: boolean;
}

export function UpdateBulkBusinessEnableBodyFromJSON(json: any): UpdateBulkBusinessEnableBody {
    return UpdateBulkBusinessEnableBodyFromJSONTyped(json, false);
}

export function UpdateBulkBusinessEnableBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBulkBusinessEnableBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'businesses': ((json['businesses'] as Array<any>).map(BusinessFromJSON)),
        'isEnabled': json['isEnabled'],
    };
}

export function UpdateBulkBusinessEnableBodyToJSON(value?: UpdateBulkBusinessEnableBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'businesses': ((value.businesses as Array<any>).map(BusinessToJSON)),
        'isEnabled': value.isEnabled,
    };
}


